import * as React from "react";

const SvgComponent = (props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.335 21.333 2.668 2.667m18.667 0L2.668 21.332" stroke="#B5B5B5" strokeWidth={4} strokeLinecap="round" />
  </svg>
);

export default SvgComponent;
